module.exports = __webpack_public_path__ + "static/media/retire-da-balanca.430b32ba.gif";